import React from 'react'

const Missing = () => (
    <h1>Sorry, an error occurred. Please refresh.</h1>
)

export default Missing



// WEBPACK FOOTER //
// ./src/components/Missing.js